import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getLoginURL } from "../../helper/funciones";

const MySwal = withReactContent(Swal);

const sqlhtml = (culpable, sqlMessage, errorSql) => {
  const sql = errorSql?.replace(/\n/g);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          fontSize: "0.9rem",
        }}
      >
        <span style={{ fontWeight: "bold" }}>sqlMessage:</span>
        <span
          style={{
            textAlign: "justify",
            flex: "1",
            marginLeft: "10px",
            fontSize: "0.8rem",
          }}
        >
          {sqlMessage}
        </span>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          fontSize: "0.9rem",
        }}
      >
        {culpable ? (
          <span style={{ fontWeight: "bold" }}>Configuracion:</span>
        ) : (
          <></>
        )}
        {culpable?.map(({ id, atributo, id_a }) => (
          <a
            key={id}
            href={`/#/Vista/PANTALLA_VISTA_CONFIGURACION?id=${id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "#007bff",
              marginBottom: "5px",
              transition: "color 0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#339af0")}
            onMouseLeave={(e) => (e.target.style.color = "#007bff")} // Opcional: estilos de enlace
          >
            <p style={{ margin: 0 }}>
              {id_a}: ver {atributo}
            </p>
          </a>
        ))}
      </div>
      <details style={{ fontSize: "0.8rem", textAlign: "left" }}>
        <summary style={{ cursor: "pointer" }}>Mostrar SQL</summary>
        <div>{sql}</div>
      </details>
    </div>
  );
};

function alertarSinAutorizacion(error) {
  const urlActual = getLoginURL()

  // Si NO hay usuario -> mostramos el botón con redirect
  const loginLink = !error?.usuario
    ? `<a id="login-link" href="${urlActual}" 
         style="color: blue; text-decoration: underline;">
         Ingresar
       </a>`
    : "";

  MySwal.fire({
    title: error.titulo ?? "No autorizado",
    icon: "warning",
    timer: 10000,
    confirmButtonText: "Aceptar",
    html: `
      <div>
        <div>${error.message}</div>
        ${loginLink}
      </div>
    `,
    showCloseButton: true,
    showConfirmButton: false,
    didOpen: () => {
      const link = document.getElementById("login-link");
      if (link) {
        link.addEventListener("click", () => {
          MySwal.close(); // <-- cerrar el modal
        });
      }
    },
  });
}

function alertarSqlError(error) {
  const { culpable, timer, sqlMessage, errorSql } = error;

  return MySwal.fire({
    title: error.code ?? error.e.code ?? "Error",
    icon: "error",
    timer: timer ?? 10000,
    confirmButtonText: "Aceptar",
    html: sqlMessage ? (
      sqlhtml(culpable, sqlMessage, errorSql)
    ) : (
      <div>{error.message}</div>
    ),
    showCloseButton: true,
    showConfirmButton: false,
  });
}

export { alertarSqlError, alertarSinAutorizacion };
